export const SNACKBAR_DEFAULT_DURATION_MS: number = 5000
export const SNACKBAR_STATIC_DURATION_MS: number = -1

export enum MessageType {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}
